import LogoDark from '@images/logoDark.svg';
export const LinkExpiredPage = () => {
  return (
    <div className={`flex items-center justify-center h-screen flex-col align-middle `}>
      <div
        className={`flex flex-col  items-center justify-center border-[1px] border-bordercolor rounded-md px-10 py-12 max-w-[470px] min-w-[350px] w-[30%]`}
      >
        <img src={LogoDark} alt="logo" className="w-[135px] h-[70px]" />

        <div className="flex flex-col gap-3 text-center pt-[30%] pb-[30%] items-center justify-center">
          <h1 className="leading-10 text-[32px] font-normal text-black">Oops! This link is no longer active.</h1>
          <p className="leading-[24px] text-base font-normal text-[#71717A]">
            The link you tried to access has expired.
          </p>
        </div>
      </div>
    </div>
  );
};
